import { PortfolioBucketMovement } from "@pages/portfolio/bucket-movement/bucket-movement";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_layout/portfolio/bucket-movement")({
	component: PortfolioBucketMovement,
});
